import { Instagram, Mail, Twitter } from "lucide-react";
import { FeedbackDialog } from "./FeedbackDialog";
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-deep-indigo text-white py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="/pokellama_logo.webp"
                alt="logo"
                className="w-10 h-10 rounded-full"
              />
              <h3 className="text-2xl font-bold font-poppins">ThePokeLlama</h3>
            </div>
            <p className="text-white/80 mb-6 max-w-md font-inter leading-relaxed">
              The ultimate platform for Pokémon card collectors. Track prices,
              manage your collection, and compete with trainers worldwide in the
              most comprehensive card tracking experience.
            </p>

            <p className="text-white/50 mb-6 max-w-md font-inter leading-relaxed">
              Disclosure: This is an affiliate link. At no additional cost to
              you, we may earn a commission if you click through and make a
              purchase.
            </p>

            {/* Newsletter Signup */}
            {/* <div className="mb-6">
              <h4 className="font-semibold mb-3 font-poppins">
                Stay updated with market trends
              </h4>
              <div className="flex space-x-2">
                <Input
                  placeholder="Enter your email"
                  className="bg-white/10 border-white/20 text-white placeholder:text-white/60 font-inter"
                />
                <Button className="bg-gradient-to-r from-electric-yellow to-holo-blue hover:from-electric-yellow/90 hover:to-holo-blue/90 text-deep-indigo font-bold font-inter">
                  Subscribe
                </Button>
              </div>
            </div> */}
          </div>

          {/* Quick Links */}
          {/* <div>
            <h4 className="font-semibold mb-4 font-poppins">Platform</h4>
            <ul className="space-y-3 text-white/80 font-inter">
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  Dashboard
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  My Binder
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  Market Data
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  Leaderboards
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  Card Scanner
                </a>
              </li>
            </ul>
          </div> */}

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4 font-poppins">Support</h4>
            <ul className="space-y-3 text-white/80 font-inter">
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  Help Center
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  API Docs
                </a>
              </li>
              <FeedbackDialog type="feedback">
                <li>
                  <a
                    href="#"
                    className="hover:text-electric-yellow transition-colors"
                  >
                    Contact Us
                  </a>
                </li>
              </FeedbackDialog>
              <FeedbackDialog type="bug">
                <li>
                  <p className="hover:text-electric-yellow transition-colors cursor-pointer">
                    Report a Bug
                  </p>
                </li>
              </FeedbackDialog>
              <li>
                <a
                  href="#"
                  className="hover:text-electric-yellow transition-colors"
                >
                  Feature Requests
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className="hover:text-electric-yellow transition-colors"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Icons & Copyright */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6">
              <a
                href="https://twitter.com/ThePokeLlama"
                target="_blank"
                className="text-white/80 hover:text-electric-yellow transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/ThePokeLlama"
                target="_blank"
                className="text-white/80 hover:text-electric-yellow transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              {/* <a
                href="#"
                className="text-white/80 hover:text-electric-yellow transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
              </a> */}
              <a
                href="mailto:fmata2008@gmail.com"
                className="text-white/80 hover:text-electric-yellow transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <p className="text-white/60 text-sm font-inter">
              &copy; 2025 ThePokeLlama. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
